import { useParams } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { currentUserAtom } from '@/stores/sessionStore'
import { getGreetingsByTime } from '@/lib/format'
import { HomeDashboard } from '@/components/compliance/HomeDashboard'

export function ChatWelcomeHeader() {
  const user = useAtomValue(currentUserAtom)
  const firstName = user?.firstName || user?.name?.split(' ')[0]
  return (
    <div className='mx-auto w-full max-w-[860px] px-4 pt-12 pb-5 lg:pt-[20vh]'>
      <div className='flex items-center gap-3'>
        <img
          src='/logos/screenata.svg'
          alt=''
          className='size-10 shrink-0 dark:invert'
        />
        <h1 className='font-heading text-3xl font-semibold tracking-tight sm:text-4xl'>
          {getGreetingsByTime(false)}
          {firstName ? `, ${firstName}` : ''}
        </h1>
      </div>
    </div>
  )
}

export function ChatWelcomeBody({
  chatEventScope: _chatEventScope,
}: {
  chatEventScope?: string | null
}) {
  const { workspaceId } = useParams({ strict: false })
  return workspaceId ? <HomeDashboard workspaceId={workspaceId} /> : null
}

export function ChatWelcome({
  chatEventScope,
}: {
  chatEventScope?: string | null
}) {
  return (
    <>
      <ChatWelcomeHeader />
      <ChatWelcomeBody chatEventScope={chatEventScope} />
    </>
  )
}
